module.exports = __webpack_public_path__ + "img/card_franchise1.abb71f50.svg";